import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Dropdown, Button } from '@salesforce/design-system-react';

import { JobTable, RemoveSelectionsButton } from '../';
import './JobPanel.scss';

class JobPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: 'sendDate',
      sortDesc: true
    };
  }

  renderJobInfoRow() {
    const { formatMessage } = this.props.intl;
    // change to components.ecs.selectionBrowser.jobs.filter.sortBy after next translation
    const sortLabel = formatMessage({
      id: 'components.ecs.analytics.perf.sortBy'
    });
    const sendLabel = formatMessage({
      id: 'components.ecs.selectionBrowser.jobs.filter.sendDate'
    });
    const openLabel = formatMessage({
      id: 'components.ecs.selectionBrowser.jobs.filter.openDate'
    });
    const count = this.props?.jobs?.length || 0;

    return (
      <div className="job-info-row">
        <h3>
          <FormattedMessage
            id="components.ecs.selectionBrowser.jobs.table.items"
            values={{ count }}
          />
        </h3>
        <RemoveSelectionsButton
          actions={this.props.actions}
          subscriber={this.props.subscriber}
        />
        <Dropdown
          align="right"
          iconCategory="utility"
          iconName="sort"
          iconSize="medium"
          iconVariant="border-filled"
          width="xx-small"
          options={[
            { label: sortLabel, type: 'header' },
            { label: sendLabel, value: 'sendDate' },
            { label: openLabel, value: 'openDate' }
          ]}
          onSelect={this.handleSortBy.bind(this)}
        />
      </div>
    );
  }

  renderJobSortRow() {
    const sortBy = `components.ecs.selectionBrowser.jobs.filter.${
      this.state.sortBy
    }`;
    const sortOrder = this.state.sortDesc ? 'arrowdown' : 'arrowup';
    return (
      <div className="job-sort-row">
        <h3>
          <FormattedMessage id={sortBy} />
          <Button
            className="sort-arrow"
            iconCategory="utility"
            iconName={sortOrder}
            iconSize="x-small"
            variant="base"
            iconVariant="bare"
            onClick={this.handleSortOrder.bind(this)}
          />
        </h3>
      </div>
    );
  }

  handleSortBy(value) {
    this.setState({ sortBy: value.value });
    this.sortJobs();
  }

  handleSortOrder() {
    this.setState({ sortDesc: !this.state.sortDesc });
    this.sortJobs();
  }

  sortJobs() {
    const jobs = this.props.jobs;
    let sortedJobs;

    if (this.state.sortDesc && this.state.sortBy === 'sendDate') {
      sortedJobs = jobs.sort(
        (a, b) => new Date(b.send.send_date) - new Date(a.send.send_date)
      );
    } else if (!this.state.sortDesc && this.state.sortBy === 'sendDate') {
      sortedJobs = jobs.sort(
        (a, b) => new Date(a.send.send_date) - new Date(b.send.send_date)
      );
    }

    if (this.state.sortDesc && this.state.sortBy === 'openDate') {
      sortedJobs = jobs.sort(
        (a, b) => new Date(b.open_date) - new Date(a.open_date)
      );
    } else if (!this.state.sortDesc && this.state.sortBy === 'openDate') {
      sortedJobs = jobs.sort(
        (a, b) => new Date(a.open_date) - new Date(b.open_date)
      );
    }
    return sortedJobs;
  }

  render() {
    return (
      <div className="jobs-pane">
        <h1>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.email.header" />
          </span>
        </h1>
        {this.renderJobInfoRow()}
        {this.renderJobSortRow()}
        <ul>
          <JobTable
            jobs={this.props.jobs}
            isLoading={this.props.isLoading}
            filter={this.state.filter}
            onJobSelected={this.props.onJobSelected}
            selectedJobId={this.props.selectedJobId}
          />
        </ul>
      </div>
    );
  }
}

JobPanel.contextTypes = {
  router: PropTypes.object
};

JobPanel.propTypes = {
  actions: PropTypes.object,
  profile: PropTypes.object,
  isLoading: PropTypes.bool,
  jobs: PropTypes.array,
  onJobSelected: PropTypes.func,
  selectedJobId: PropTypes.string,
  subscriber: PropTypes.string,
  location: PropTypes.object
};

export default injectIntl(JobPanel);
